module.exports = __webpack_public_path__ + "static/media/marvel.cc6ea79f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/marvel.jpeg
// module id = 288
// module chunks = 0